import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import 'animate.css/animate.min.css';
import ScrollAnimation from 'react-animate-on-scroll';

import { Section, Container } from '../../components/globalSectionContainer';

const ITEM_COLLECTION = [
  {
    name: 'Ергономичен дизайн',
    image: '1.jpg',
  },
  {
    name: 'Малки и удобни',
    image: '2.jpeg',
  },
  {
    name: 'Зарядна станция',
    image: '3.jpg',
  },
  {
    name: 'Blutooth технология',
    image: '4.jpg',
  },
  {
    name: 'Малък размер',
    image: '5.jpg',
  },
  {
    name: 'Елегантен дизайн',
    image: '6.jpg',
  },
];

const WhyToBuy = () => (
  <StaticQuery
    query={graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "team" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(maxWidth: 400, maxHeight: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        art_team: file(
          sourceInstanceName: { eq: "team" }
          name: { eq: "airpods" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section
        id="why to buy" //accent="secondary"
      >
        <Container style={{ position: 'relative', textAlign: 'center' }}>
          <ScrollAnimation animateIn="flipInY" animateOut="flipOutY">
            <h1>Защо да купим</h1>
          </ScrollAnimation>
          <ItemsmGrid>
            {ITEM_COLLECTION.map(({ name, image }) => {
              const img = data.allFile.edges.find(
                ({ node }) => node.relativePath === image
              ).node;

              return (
                <div key={name}>
                  <ScrollAnimation animateIn="fadeIn" duration={4}>
                    <Img fluid={img.childImageSharp.fluid} alt={name} />

                    <Title>{name}</Title>
                  </ScrollAnimation>
                </div>
              );
            })}
          </ItemsmGrid>
          <Art>
            <Img fluid={data.art_team.childImageSharp.fluid} />
          </Art>
          <ArtMobile>
            <Img fluid={data.art_team.childImageSharp.fluid} />
          </ArtMobile>
        </Container>
      </Section>
    )}
  />
);

const ItemsmGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-template-rows: min-content;
  grid-gap: 50px;
  justify-content: space-between;
  width: 60%;
  margin-top: 72px;

  @media (max-width: ${props => props.theme.screen.lg}) {
    justify-content: start;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  @media (max-width: ${props => props.theme.screen.xs}) {
    grid-gap: 24px;
  }
`;

const Art = styled.figure`
  width: 800px;
  margin: -80px 0;
  position: absolute;
  top: 0;
  left: 70%;

  @media (max-width: ${props => props.theme.screen.lg}) {
    top: 20%;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    display: none;
  }
`;

const ArtMobile = styled.figure`
  width: 100%;
  margin: 0;
  display: none;
  margin-top: 64px;
  margin-bottom: -60%;

  @media (max-width: ${props => props.theme.screen.md}) {
    display: block;
  }
`;

const Title = styled.p`
  margin-top: 16px;
  color: ${props => props.theme.color.black.regular};
`;

export default WhyToBuy;
